<template>
  <b-modal v-model="isOpen" body-class="device-modal-body" header-class="device-modal-header" hide-backdrop no-close-on-esc no-close-on-backdrop hide-header-close hide-footer centered ok-only size="md">
    <template #modal-header>
      <strong>Add a New Device</strong>
    </template>

    <CCol>
      Please be aware that this device will recieve a share of your active bandwidth.
    </CCol>
    <br />
    <div>
      Device Type:<br />
      <devicetype-selection @device-selected="handleDeviceSelection" ></devicetype-selection>

      <label class="mt-2" for="description">Description:</label><br />
      <input class="device-description-input" type="text" v-model="description" placeholder="Enter description" id="description" />

      <br /><br />
      <label>MAC Address:</label><br />
      <macaddress-input @validMacAddress="handleMacAddress" @invalidMacAddress="handleInvalidMac" />
    </div>
    <p v-if='isLocal' class="invalid-border">     
      Warning! This address is a private generated address. We recommend turning
      off private wifi address settings as this prevents the device being recognised 
      next time you try to connect.
    </p>
    <div v-if='errorMessage' class="invalid-border">      
      {{ errorMessage }}
    </div>
    <br v-if="errorMessage" />
    <br v-if="!isLocal && !errorMessage" />
    <CRow>
    <CCol xl="1" lg="1" md="1" sm="1" xs="1">
      <input type="checkbox" id="accept-terms-checkbox" v-model="acceptedTerms" />
    </CCol>
    <CCol xl="11" lg="11" md="11" sm="11" xs="11">
      <label for="accept-terms-checkbox">I certify that this device is my personal property and its registration complies with the <a style="color: yellow" :href="uiSettings.termsAndConditions" target="_blank"><u>SoldierNET Terms of Service</u></a> and usage policy.</label>
    </CCol>
    </CRow>
    <div class="mt-4">
      <button @click="close" class="device-buttons">Cancel</button>
      <button @click="submit" class="device-buttons add-device-button" :disabled='isLocal || !acceptedTerms || !isValid'>Add Device</button>
    </div>
  </b-modal>
</template>

<script>
import MacaddressInput from './MacaddressInput.vue';  // Assuming you named the MAC address component as MacAddressInput
import DevicetypeSelection from './DevicetypeSelection.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    MacaddressInput,
    DevicetypeSelection
  },
  props: {
    isOpen: Boolean,
    errorMessage: String
  },
  data() {
    return {
      description: '',
      deviceType: 'phone',  // default device type
      macAddressInstance: null,
      acceptedTerms: false
    };
  },
  computed: {
    ...mapGetters({
        uiSettings: "pricing/getUiSettings"
    }),
    isLocal() {
      return this.macAddressInstance != null ? this.macAddressInstance.isLocal() : false
    },
    isValid(){
      return this.macAddressInstance != null && this.deviceType != null && this.macAddressInstance.address.replace(/-/g, '').length === 12;
    }
  },
  methods: {
    handleMacAddress(macInstance) {
      if (macInstance.isLocal() != null) {
        this.macAddressInstance = macInstance;
        this.$emit("clear-error-message");
      } else {
        this.macAddressInstance = null;
      }
    },
    handleInvalidMac() {
      this.macAddressInstance = null;
    },
    handleDeviceSelection(device) {
      this.deviceType = device;      
    },
    submit() {
      this.$log.onError('submit init')
      if (this.macAddressInstance) {
        // checks
        // 1. is the device currently registered to another account?
        // 2. 
        // Here, emit the data or save it wherever you need
        this.$emit('newDevice', {
          description: this.description,
          deviceType: this.deviceType,
          macAddress: this.macAddressInstance
        });
      }
    },
    close() {
      this.macAddressInstance = null;
      this.$emit('closeModal');
    }
  }
}
</script>

<style scoped>
.invalid-border {
  border: 2px solid red;
  margin-top: 1rem;
  padding: 1rem;
  border-radius: 6px;
  background: lightgray;
  color: red;
  font-weight: 600;
}

::v-deep .device-modal-header {
  background:#55235c !important;
  color: #ffff33 !important;
  border-radius: 12px 12px 0 0;
}

::v-deep .device-modal-body {
  background:#712d71 !important;
  color: #ffff2d !important;
  border-radius: 0 0 12px 12px;
}

::v-deep .modal-content {
  border-radius: 16px;
}

.device-description-input {
  border-radius: 6px !important;
  width: 16rem;
}

.device-buttons {
  border-radius: 6px;
}

.device-buttons:hover {
  background: #aaaaaa;
}

.add-device-button {
  float: right;
}
/*
#modal-header {
  
}
.modal {

}
.modal-content {

} */
</style>


